export var api_endpoint = "https://thailandsmarttour-api.dot.go.th";